module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.c69cffc5.svg";